export default async function GetSplitPlanApi(planId, page, limit) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${planId}/split-plans?startAt=${page}&limit=${limit}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error get split plans: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
